import type { AudienceOption } from '@openx/types/targeting/audience.ts';
import type {
  OptionsFetchResponse,
  UseAudienceOptionsDetailsFetchFn,
} from '@openx/types/targeting/targetingHookTypes.ts';

import { useAudienceOptionsFetch } from './useAudienceOptionsFetch.ts';

export const useAudienceOptionsDetailsFetch: UseAudienceOptionsDetailsFetchFn = (
  accountUid: string,
  type: AudienceOption | null
): OptionsFetchResponse => {
  return useAudienceOptionsFetch(accountUid, type);
};
